import { Remotes } from './types';

export default [
  {
    url: '/assets/projects/assets-no-cache/remoteEntry.js',
    scope: 'accProjectList',
  },
  {
    url: '/assets/demo-app/assets-no-cache/remoteEntry.js',
    scope: 'accDemoApp',
  },
  {
    url: '/assets/bridge/assets-no-cache/remoteEntry.js',
    scope: 'accBridge',
  },
  {
    url: '/assets/components/assets-no-cache/remoteEntry.js',
    scope: 'accLibrary',
  },
  {
    url: '/assets/template-admin/assets-no-cache/remoteEntry.js',
    scope: 'accTemplateAdmin',
  },
  {
    url: '/assets/template-settings/assets-no-cache/remoteEntry.js',
    scope: 'accTemplateSettings',
  },
] satisfies Remotes;
